import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { useCallback, useState } from 'react';
import { mapOptions } from './configuration';

const containerStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '50px',
    overflow: 'hidden',
};

const center = {
    lat: 47.39254,
    lng: 8.04422,
};

const Map = () => {
    const [, setMap] = useState<google.maps.Map | null>(null);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: mapOptions.googleMapApiKey,
    });

    const onLoad = useCallback((mapInstance: google.maps.Map) => {
        // const bounds = new window.google.maps.LatLngBounds(center);
        // mapInstance.fitBounds(bounds);
        setMap(mapInstance);
    }, []);

    const onUnmount = useCallback(() => {
        setMap(null);
    }, []);

    if (!isLoaded) return null;

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={9}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
                disableDefaultUI: true,
                zoomControl: true,
            }}
        >
          <Marker position={center} />
        </GoogleMap>
    );
};

export default Map;
